import { Grid, Stack } from "@mui/material";
import { Show, Tab, TabbedShowLayout } from "react-admin";
import VendorTipMetaShow from "./VendorTipMetaShow";

const RenderCTAButtons = (props: any) => {
  return (
    <Stack p={2}>
      <Grid container spacing={2} justifyContent="flex-end">
      </Grid>
    </Stack>
  );
};

const VendorTipTabShow = () => {

  return (
    <TabbedShowLayout>
      <Tab label={"Details"}>
        <VendorTipMetaShow/>
      </Tab>
    </TabbedShowLayout>
  );
};
const VendorTipShow = (props: any) => {
  return (
    <div>
      <Show {...props} actions={false}>
        <RenderCTAButtons/>
        <VendorTipTabShow />
      </Show>
    </div>
  );
};
export default VendorTipShow;